import Vue from 'vue';
import App from '~/js/layouts/App.vue';
Vue.component('app', App);
var apps = new Vue();
apps.$mount('#apps');
